module.exports = __webpack_public_path__ + "img/deep1.db278ed9.png";